import { pgEnum } from 'drizzle-orm/pg-core';
export const resourceStatus = pgEnum('resource_status', ['active', 'inactive']);
//# sourceMappingURL=resource-status.js.map